<app-group-header [Heading]="'Vertikale Strecke' | translate"
                  [chart]="chart"
                  [info]="info"
                  [noChart]="true"
                  (chartEvent)="getChartEvent($event)"
                  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">
    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Error]="Kilometer?.isError"
                      [ErrorLevel]="Kilometer?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Kilometer?.TimeseriesData]"
                      [MaintenanceValue]="Kilometer?.ValueLastService"
                      [Unit]="'km'"
                      [Legend]="['Distanz' | translate, 'Distanz stand Wartung' | translate]"
                      [Info]="'Strecke, die der Heber in Kilometern schon zurückgelegt hat'"
                      [resizeEvent]="childResizeEvent"></app-default-card>
</div>
